// extracted by mini-css-extract-plugin
export var actionText = "_pg-4";
export var container = "_pg-0";
export var leftSection = "_pg-1";
export var rightSection = "_pg-2";
export var settingsButton = "_pg-6";
export var settingsIcon = "_pg-7";
export var shortcut = "_pg-5";
export var shortcutGroup = "_pg-3";